import * as yup from 'yup';

const customUrlPattern =
    /^(?:(?:(?:https?):)?\/\/)?(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

const linkedinUrlPattern = /^(http(s)?:\/\/)?([a-z]{2,3}\.)?linkedin\.com\/.*$/gim;

const twitterHandlePattern = /^(@)?([a-z0-9_]{1,15})$/i;

const validationSchema = yup
    .object()
    .shape({
        firstName: yup.string().trim().max(50, '50 characters max').required('Required field'),
        lastName: yup.string().trim().max(50, '50 characters max').required('Required field'),
        title: yup.string().trim().max(150, '150 characters max'),
        company: yup.string().trim().max(150, '150 characters max'),
        summary: yup.string().trim().max(5000, '5000 characters max'),
        web: yup.string().trim().matches(customUrlPattern, {
            message: 'Please enter a valid URL',
            excludeEmptyString: true,
        }),
        linkedinId: yup.string().trim().matches(linkedinUrlPattern, {
            message: 'Please enter a valid LinkedIn URL',
            excludeEmptyString: true,
        }),
        twitterHandle: yup.string().trim().matches(twitterHandlePattern, {
            message: 'Please enter a valid Twitter handle',
            excludeEmptyString: true,
        }),
    })
    .required();

export default validationSchema;
